// permit.util.ts
import { CommonMethods } from './common-methods.service';
import { Strings } from '../constants/strings';


export interface PermitControl {
  PermitNoText: string;
  PermitIssueDateTimeText: string;
  PermitExpireDateTimeText: string;
  PermitRequestorText: string;
  SiteText: string;
  AreaText: string;
}

export interface DefaultTextChanges {
  HasPermitNoTextChanged: boolean;
  HasPermitIssueDateTimeText: boolean;
  HasPermitExpireDateTimeText: boolean;
  HasRequestorNameTextChanged: boolean;
  HasSiteTextChanged: boolean;
  HasAreaTextChanged: boolean;
}

export function getDefaultTranslationChanges(control: PermitControl | null): DefaultTextChanges {
  return {
    HasPermitNoTextChanged: CommonMethods.checkTextChanged(control?.PermitNoText, Strings.DefaultPermitNoText),
    HasPermitIssueDateTimeText: CommonMethods.checkTextChanged(control?.PermitIssueDateTimeText, Strings.DefaultIssueDateTimeText),
    HasPermitExpireDateTimeText: CommonMethods.checkTextChanged(control?.PermitExpireDateTimeText, Strings.DefaultPermitExpiryDateTimeText),
    HasRequestorNameTextChanged: CommonMethods.checkTextChanged(control?.PermitRequestorText, Strings.DefaultPermitRequestorText),
    HasSiteTextChanged: CommonMethods.checkTextChanged(control?.SiteText, Strings.DefaultPermitSiteText),
    HasAreaTextChanged: CommonMethods.checkTextChanged(control?.AreaText, Strings.DefaultPermitAreaText)
  };
}
